import { HStack, RadioCard } from "@chakra-ui/react";
import { UI } from "components";

export default function Radio({ label, icon, options = [], ...props }){
    return(
    <RadioCard.Root defaultValue={1} name="test">
        <RadioCard.Label children={label} />
        <HStack align="stretch">
            { options.map(item => <Option key={item.value} data={item} />)}
        </HStack>
    </RadioCard.Root>
    )
}

const Option = ({ data }) => {
    return(
    <RadioCard.Item disabled={data.disabled}>
        <RadioCard.ItemHiddenInput value={data.value} checked />
        <RadioCard.ItemControl>
            <RadioCard.ItemContent>
                { data.icon && <UI.Icon name={data.icon} /> }
                <RadioCard.ItemText children={data.label} />
                <RadioCard.ItemDescription children={data.description} />
                <RadioCard.ItemIndicator />
            </RadioCard.ItemContent>
        </RadioCard.ItemControl>
    </RadioCard.Item>
    )
}